import { Link } from "react-router-dom"
export default function MintToComment({text, to}) {
  return (
    <div className="flex flex-row shadow-xl border-2 border-slate-500 w-full rounded-md p-4">
      <Link to={to}><div className="hover:underline text-primary my-auto flex content-center">{text}</div></Link>
    </div>
  )
}